import { createFileRoute } from '@tanstack/react-router';

import { AdminTemplatesView } from 'src/sections/admin/templates/templates-view';
import {
  parseTemplatesSearch,
  resolveTemplatesSearch,
} from 'src/sections/admin/templates/templates-search';

// Platform-admin home for emails: a cross-tenant feed of recently created
// emails (White Glove by default), plus the global library and section tabs.
// Tab, filters and page live in the URL so a view is shareable and survives
// reloads and back/forward.
export const Route = createFileRoute('/admin-skidog/templates')({
  validateSearch: parseTemplatesSearch,
  component: AdminTemplatesPage,
});

function AdminTemplatesPage() {
  const search = Route.useSearch();
  return <AdminTemplatesView search={resolveTemplatesSearch(search)} />;
}
